import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { SKIP_HTTP_LOADING } from '../http/http-loading.context';
import { HttpLoadingService } from '../services/http-loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_HTTP_LOADING) || !isTrackedApiRequest(req.url)) {
    return next(req);
  }

  const loading = inject(HttpLoadingService);
  loading.begin();
  return next(req).pipe(finalize(() => loading.end()));
};

function isTrackedApiRequest(url: string): boolean {
  if (!url || url.startsWith('assets/') || url.includes('app-config.json')) {
    return false;
  }

  const apiRoot = API_BASE_URL.replace(/\/+$/, '');
  if (apiRoot.startsWith('http')) {
    return url.startsWith(apiRoot);
  }

  return url.includes('/api');
}
